import { useSearchParams } from "@shared/react-router-dom/react-router-dom";

import { useFlippers } from "../useFlippers/useFlippers";

const RUPA_REDIRECT_UTM = {
  utm_source: "acquired-partners",
  utm_medium: "rupa",
  utm_campaign: "rupa-redirect",
} as const;

const useIsRupaRedirectExperience = (): boolean => {
  const [isRupaRedirectEnabled] = useFlippers("sonic_rupa_signup_redirect");
  const [searchParams] = useSearchParams();

  return (
    isRupaRedirectEnabled &&
    searchParams.get("utm_source") === RUPA_REDIRECT_UTM.utm_source &&
    searchParams.get("utm_medium") === RUPA_REDIRECT_UTM.utm_medium &&
    searchParams.get("utm_campaign") === RUPA_REDIRECT_UTM.utm_campaign
  );
};

export { useIsRupaRedirectExperience, RUPA_REDIRECT_UTM };
